import React, { useState, useEffect } from "react";
import { Dialog, Tooltip } from "@mui/material";
import moment from "moment";

import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import EnhanceDataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import { LastUpdatedDetails } from "../../stockManagement/materialDistribution/helper";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";

import { getEditLogs } from "./helper";

const ViewEditLogs = ({ open, heading, closeLogs, category, psid }) => {
  const [isFetching, setIsFetching] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async (page = currentPage, limit = pageSize) => {
    const response = await getEditLogs({
      psid,
      category,
      page,
      limit,
    });

    setIsFetching(false);

    setRowData(response?.studentDetailAuditLogDTOList || []);
    setTotalRows(response?.totalRecords || 0);
  };

  const nextButtonHandler = (pageNum, updatedPageSize) => {
    setCurrentPage(pageNum);
    setPageSize(updatedPageSize);

    fetchLogs(pageNum, updatedPageSize);
  };

  const columns = [
    new AGridColDef("ticketId", "Ticket Id").renderCellComponent((params) => (
      <div className="m-auto">{params.value}</div>
    )),

    new AGridColDef("ticketDate", "Ticket Date").renderCellComponent(
      (params) => (
        <div className="m-auto">
          {moment(params.value).format("YYYY-MM-DD")}
        </div>
      )
    ),

    new AGridColDef(
      "ticketDescription",
      "Ticket Description"
    ).renderCellComponent((params) => (
      <Tooltip title={params?.value}>
        <div className="ellipsis-text-container">{params.value}</div>
      </Tooltip>
    )),

    new AGridColDef("fieldUpdated", "Field").renderCellComponent((params) =>
      params?.value ? (
        <Tooltip title={params?.value}>
          <div className="ellipsis-text-container">{params?.value}</div>
        </Tooltip>
      ) : (
        <div className="m-auto">-</div>
      )
    ),
    new AGridColDef("oldValue", "Old Value").renderCellComponent((params) =>
      params?.value?.trim() ? (
        <Tooltip title={params?.value}>
          <div className="ellipsis-text-container">{params?.value}</div>
        </Tooltip>
      ) : (
        <div className="m-auto">-</div>
      )
    ),
    new AGridColDef("newValue", "New Value").renderCellComponent((params) =>
      params?.value ? (
        <Tooltip title={params?.value}>
          <div className="ellipsis-text-container">{params?.value}</div>
        </Tooltip>
      ) : (
        <div className="m-auto">-</div>
      )
    ),
    new AGridColDef("updatedOn", "Updated On").renderCellComponent((params) => (
      <div className="m-auto">{LastUpdatedDetails(params.value)}</div>
    )),

    new AGridColDef("updatedBy", "Updated By").renderCellComponent((params) => (
      <div className="m-auto">{params.value}</div>
    )),
  ];

  return (
    <Dialog
      aria-label="Edit History"
      open={open}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          height: "520px",
          minWidth: "800px",
          padding: "20px",
        },
      }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0 text-bold">{heading} Edit History</h3>

        <IconButtonWrapper
          aria-label="Close the dialog"
          //   tabIndex="0"
          onClick={closeLogs}
          disabled={isFetching}
        >
          <CrossIcon />
        </IconButtonWrapper>
      </div>

      <EnhanceDataGrid
        removeWrapperContainer
        rows={rowData || []}
        columns={columns}
        rowId={(row) => row.id}
        rowHeight={50}
        loading={isFetching}
        rowCount={totalRows}
        nextButtonHandler={nextButtonHandler}
        currentPage={currentPage}
        paginationModel={{
          page: currentPage,
          pageSize: pageSize,
        }}
      />

      {/* <footer className="mt-auto ml-auto">
        <AButton variant="outline" size="sm" onClick={closeLogs}>
          Close
        </AButton>
      </footer> */}
    </Dialog>
  );
};

export default ViewEditLogs;
